// version will be changed by ci
export default 'v2.8.0-hf01';
